import BreakPrompt from './BreakPrompt'
import enhance from './BreakPrompt.enhancer'

export default enhance(BreakPrompt)



// WEBPACK FOOTER //
// ./src/components/BreakPrompt/index.js